// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function TreePalmIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M29.724 6.654a8.358 8.358 0 0 0-12.218 0A9.028 9.028 0 0 0 16 8.779a9.026 9.026 0 0 0-1.5-2.125 8.357 8.357 0 0 0-12.217 0 1 1 0 0 0 .325 1.606l7.017 3.059a8.927 8.927 0 0 0-5.42 4.151 8.83 8.83 0 0 0-.9 6.79 1 1 0 0 0 1.57.535L15 15.085V28a1 1 0 0 0 2 0V15.085l10.125 7.71a1 1 0 0 0 1.571-.535 8.829 8.829 0 0 0-.9-6.79 8.927 8.927 0 0 0-5.421-4.151l7.027-3.059a1 1 0 0 0 .325-1.606h-.003ZM8.385 6a6.391 6.391 0 0 1 4.66 2.033 7.066 7.066 0 0 1 1.783 3.366L4.875 7.066A6.313 6.313 0 0 1 8.385 6ZM5 20.188a6.853 6.853 0 0 1 .934-3.713 6.944 6.944 0 0 1 4.25-3.236 7.062 7.062 0 0 1 3.857.062L5 20.187Zm21.063-3.713A6.853 6.853 0 0 1 27 20.187L17.962 13.3a7.038 7.038 0 0 1 8.104 3.175h-.003Zm-8.89-5.076a7.066 7.066 0 0 1 1.782-3.366A6.392 6.392 0 0 1 23.615 6c1.25 0 2.471.371 3.51 1.066L17.172 11.4Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
